import { render } from "./SummaryCards.vue?vue&type=template&id=f24cb862&scoped=true"
import script from "./SummaryCards.vue?vue&type=script&lang=js"
export * from "./SummaryCards.vue?vue&type=script&lang=js"

import "./SummaryCards.vue?vue&type=style&index=0&id=f24cb862&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24cb862"]])

export default __exports__